import { buildUrl } from "@lgp/shared/utils/url";

const { REACT_APP_API_URL, REACT_APP_ASSETS_URL } = process.env;

/**
 * Normalizes handling the API responses.
 * @param {Response} res
 * @returns {any}
 */
const handleResponse = async (res) => {
  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch (err) {
    data = text;
  }

  if (res.status >= 400) {
    let error;
    // Handle JSON error response.
    if (typeof data === "object") {
      error = new Error(
        data.message || data.error_description || res.statusText
      );
      error.code = res.status;
      if (data.errors) {
        error.errors = data.errors;
      } else if (data.data) {
        error.errors = data.data;
      }
    } else {
      // Handle text error response.
      error = new Error(res.statusText);
      error.code = res.status;
    }

    throw error;
  }

  return data;
};

/**
 * Http client to make calls to the LGP API
 */
class ApiClient {
  /**
   * Sets the base url used by this client.
   * @param {String} baseUrl
   */
  constructor(baseUrl) {
    this.baseUrl = new URL(baseUrl);
  }

  /**
   * Returns the base url.
   * @returns {String}
   */
  getBaseUrl() {
    return this.baseUrl.toString();
  }

  /**
   * Makes HTTP request.
   *
   * @param {String} method
   * @param {String} path
   * @param {Object} options
   * @param {Object<string, string>} options.headers
   * @param {Object<string, string|number>} options.params
   * @param {Object<string, any>} options.data
   * @returns
   */
  async makeRequest(method, path, options = {}) {
    const {
      headers = {},
      params = {},
      data,
      files,
      corsMode = "cors",
    } = options;
    const baseUrl = this.getBaseUrl();
    const url = buildUrl(baseUrl, path, params);
    const newHeaders = {
      ...headers,
    };

    // Default to JSON content type.
    if (!newHeaders["Accept"] || !newHeaders["Content-Type"]) {
      newHeaders["Accept"] = "application/json";
      newHeaders["Content-Type"] = "application/json";
    }

    const newRequestOptions = {
      method: method.toUpperCase(),
      headers: newHeaders,
    };

    if (corsMode === "cors") {
      newRequestOptions.mode = corsMode;
    }

    if (Array.isArray(files) && files.length > 0) {
      const formData = new FormData();

      // Set the files.
      for (let i = 0; i < files.length; i += 1) {
        formData.append("files", files[i]);
      }

      // Set the JSON data.
      if (data) {
        formData.append("document", JSON.stringify(data));
      }

      newRequestOptions.body = formData;

      delete newRequestOptions.headers["Content-Type"];
    } else if (data) {
      newRequestOptions.body = JSON.stringify(data);
    }

    const res = await fetch(url.href, newRequestOptions);
    return handleResponse(res);
  }
}

export const lgpClient = new ApiClient(REACT_APP_API_URL);
export const assetsClient = new ApiClient(REACT_APP_ASSETS_URL);

export default ApiClient;
// F1MIHTGFRRTB
